module.exports = __webpack_public_path__ + "static/media/thumbnail.2de67680.jpg";